module.exports = __webpack_public_path__ + "img/photo-01.cec960e4.png";